import AddIcon from '@mui/icons-material/Add';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { Box, Grid, Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { ControlledTextInput, Label, WsColors } from 'wisestep-base';

const LinkTag = styled(Link)(() => ({
  color: WsColors.TheBlues500,
  cursor: 'pointer',
}));

const OtherInfoFields = ({
  name = 'otherInfo',
  showMandatorySymbol = false,
}: {
  name?: string;
  showMandatorySymbol?: boolean;
}) => {
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({ control, name });

  return (
    <Box ml={2}>
      <Label>Other Information {showMandatorySymbol && `*`}</Label>

      {fields.map((field, index) => (
        <Box key={field.id} display="flex" alignItems="flex-start" gap={1} pb={0.5}>
          <Box>
            <ControlledTextInput
              name={`${name}.${index}.key`}
              placeholder="Field Name (e.g. Passport)"
              labelText=""
              sx={{ '& .MuiInputBase-input': { height: 22, p: 0 } }}
            />
          </Box>

          <Box>
            <ControlledTextInput
              name={`${name}.${index}.value`}
              placeholder="Field Value (e.g. A1234567)"
              labelText=""
              sx={{ '& .MuiInputBase-input': { height: 22, p: 0 } }}
            />
          </Box>

          {index !== 0 && (
            <Box>
              <RemoveCircleOutlineIcon
                onClick={() => remove(index)}
                sx={{
                  color: WsColors.Red400,
                  cursor: 'pointer',
                  fontSize: '24px',
                }}
              />
            </Box>
          )}
        </Box>
      ))}

      <Box width="fit-content">
        <LinkTag underline="none" onClick={() => append({ key: '', value: '' })}>
          <Grid container direction="row" alignItems="center">
            <Grid item>
              <AddIcon />
            </Grid>
            <Grid item>Add More</Grid>
          </Grid>
        </LinkTag>
      </Box>
    </Box>
  );
};

export default OtherInfoFields;
